export interface cv_MaterialPoolStatus {
    C_MaterialPoolStatus_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDefaultEndState: boolean;
    IsDeprecated: boolean;
    IsEndState: boolean;
    MaterialPoolStatus: string;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
